
export const map_review_permissios ={
    required_permission: ["add_review", "change_review", "delete_review", "view_review"],
}